export default __webpack_public_path__ + "static/media/2.157ed5a7.jpg";